import React from "react";
import Typography from "@material-ui/core/Typography";
import TablaDetalleDiferencias from "../components/TablaDetalleDifJerarquia";
import {diferenciasResources} from "../endpoints";
import CardTotales from "../components/CardTotales";

class DetalleDifJerarquia extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            jerarquia: " ",
            tipo: props.match.params.tipo,
            id: props.match.params.id,
            valor: props.match.params.cantidad,
            id_filtro: props.match.params.filtro,
            datos: {},
            filtro_descripcion:"",
            filtro:"",
            valor_filtro:0,
            ocultarFiltro:false,
        }
    }

    UNSAFE_componentWillMount() {
        this.setearFiltros()
        this.obtenerDatos()
    }

    obtenerDatos= () =>{
        if (this.state.tipo ==='jerarquia'){
            diferenciasResources.getDatosJerarquia(this.state.id).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(result => {
                this.setState({jerarquia:result.descripcion, datos: result})
            }).catch(error=> {
                console.log(error)
            });
        }
        else{
            diferenciasResources.getDatosUbicacion(this.state.id).then(async response => {
                if (response.ok) {
                    return await response.json();
                } else {
                    throw new Error('Something went wrong ...');
                }
            }).then(result => {
                this.setState({jerarquia:result.descripcion, datos: result})
            }).catch(error=> {
                console.log(error)
            });
        }

    }

    setearFiltros = ()=>{
        if (this.state.id_filtro === "1"){
            this.setState({filtro_descripcion:'Monto $', filtro:"monto"})
        }
        else if (this.state.id_filtro === "2"){
            this.setState({filtro_descripcion:'Top',filtro:"top"})
        }else if (this.state.id_filtro === "-1"){
            this.setState({ocultarFiltro:true,filtro_descripcion:'Ninguno',filtro:"ninguno"})
        }
        else{
            this.setState({filtro_descripcion:'Top %',filtro:"top_porcentual"})
        }
        if (this.state.valor === "-----------"){
            this.setState({valor_filtro:0})
        }
        else{
            this.setState({valor_filtro:this.state.valor})
        }
    }
    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>Detalle diferencias {this.state.tipo}: {this.state.jerarquia}</Typography>
                {!this.state.ocultarFiltro && <Typography variant="h5" gutterBottom>Filtro: {this.state.filtro_descripcion} / Valor: {this.state.valor}</Typography>}
                {this.state.ocultarFiltro && <Typography variant="h5" gutterBottom>Conteo en 0</Typography>}
                <CardTotales datos={this.state.datos}/>
                <br/>
                <TablaDetalleDiferencias id={this.state.id} tipo={this.state.tipo} filtro={this.state.filtro} valor={this.state.valor_filtro}/>
            </div>
        )
    }
}

export default DetalleDifJerarquia